import _styled from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';
const DefaultContentSmall = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    style,
    className,
    open,
    disabled,
    title,
    linkText
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    className: className,
    $_css: [style]
  }, (title || T.translate('DRAG_FILES_HERE_OR')) + ' ', /*#__PURE__*/React.createElement(LinkButton, {
    disabled: disabled,
    onClick: e => {
      open && open();
      // that is because the entire dropzone is clickable
      e.stopPropagation();
    }
  }, linkText || T.translate('CHOOSE_FILES_LOWER')));
});
DefaultContentSmall.displayName = 'DefaultContentSmall';
DefaultContentSmall.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Function that opens file browser */
  open: PropTypes.func,
  /** Whether dropzone is disabled */
  disabled: PropTypes.bool
};
export default DefaultContentSmall;
var _StyledDiv = _styled("div").withConfig({
  displayName: "DefaultContentSmall___StyledDiv",
  componentId: "sc-1cuo14a-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=DefaultContentSmall.js.map